/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

// Default timeout for Chrome
const timeout = 500000;

// Create different Axios instances for different hosts
const selfHostedInstance = axios.create({
  baseURL: "/",
  timeout,
});

const uhfAxiosInstance = axios.create({
  baseURL: "https://uhf.microsoft.com",
  timeout,
});

// Store the instances in an array or an object with keys based on the host
export const axiosInstances: { [key: string]: AxiosInstance } = {
  self: selfHostedInstance,
  "uhf.microsoft.com": uhfAxiosInstance,
};

export const simpleAxiosUrlFetch = (options: AxiosRequestConfig) => {
  const { url } = options;

  if (!url) {
    throw new Error(`URL in undefined`);
  }

  if (url.startsWith("/")) {
    // Use the self-hosted instance for relative URLs
    return axiosInstances.self(options);
  }

  const host = new URL(url as string).host;
  const axiosInstance = axiosInstances[host];

  if (!axiosInstance) {
    throw new Error(`No Axios instance found for host: ${host}`);
  }

  return axiosInstance(options);
};

export const getFetchGetOptions = (url: string): AxiosRequestConfig => ({
  method: "get",
  url,
  timeout,
});

export const getSavePostOptions = (url: string, body?: any): AxiosRequestConfig => ({
  method: "post",
  url,
  data: body,
  timeout,
});
